import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-505da658"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/svg/Cloud_Error.svg" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/svg/Cloud_Error.svg" }, null, -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "md:container lg:flex md:mx-auto" }
const _hoisted_5 = { class: "overview-item row lg:block items-center lg:w-1/3 lg-boxed-container lg:p-4 self-start z-50 top-0 lg:top-4" }
const _hoisted_6 = { class: "mb-8 mt-0 hidden lg:block" }
const _hoisted_7 = { class: "mt-0" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { class: "lg:w-2/3" }
const _hoisted_15 = { class: "pb-8 -mt-8 pt-8 container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_toolbar = _resolveComponent("toolbar")!
  const _component_tabs = _resolveComponent("tabs")!
  const _component_HzbaMainView = _resolveComponent("HzbaMainView")!
  const _component_HzbaSummary = _resolveComponent("HzbaSummary")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_toolbar, {
        title: _ctx.baSubpage === 'summary' ? 'Vorschau' :`HZBA - ${_ctx.immobilie ? _ctx.immobilie.externeObjektNr : '...'}`
      }, {
        leading: _withCtx(() => [
          _createVNode(_component_ion_buttons, { slot: "start" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_button, {
                fill: "clear",
                color: "light",
                class: "px-0 -ml-4",
                size: "small",
                onClick: _cache[0] || (_cache[0] = () => _ctx.goBackFromSummary())
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.arrowBack,
                    size: "large"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              (_ctx.networkStatus === ('none' || 'undefined') && _ctx.baSubpage !== 'summary')
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: _ctx.networkStatus,
                    "data-cy": "network-status"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        trailing: _withCtx(() => [
          _createVNode(_component_ion_buttons, { slot: "primary" }, {
            default: _withCtx(() => [
              (_ctx.networkStatus === ('none' || 'undefined') && _ctx.baSubpage === 'summary')
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: _ctx.networkStatus,
                    "data-cy": "network-status"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.baSubpage !== 'summary')
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 1,
                    "data-cy": "button-preview",
                    onClick: _ctx.showSummary
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("hzba.buttons.vorschau")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          (_ctx.ba)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h3", _hoisted_7, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("hzba.uebersicht.objektTitel")) + " " + _toDisplayString(_ctx.immobilie && _ctx.immobilie.externeObjektNr), 1),
                        _hoisted_8,
                        _createTextVNode(_toDisplayString(_ctx.getLocalization(_ctx.ba.name)), 1)
                      ]),
                      (_ctx.ba.begehungsdatum)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t("hzba.uebersicht.datumTitel")) + ": " + _toDisplayString(new Date(_ctx.ba.begehungsdatum).toLocaleString("de-De")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.ba.updatedAt)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t("hzba.uebersicht.updateAmTitel")) + " " + _toDisplayString(new Date(_ctx.ba.updatedAt).toLocaleString("de-De")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.ba.updatedBy?.username)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t("hzba.uebersicht.updateVonTitel")) + " " + _toDisplayString(_ctx.ba.updatedBy?.username), 1))
                        : _createCommentVNode("", true),
                      (_ctx.HzbaStatus[_ctx.ba.status])
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t("hzba.uebersicht.statusTitel")) + ": " + _toDisplayString(_ctx.translatedHzbaStatus(_ctx.ba.status, _ctx.t)) + " " + _toDisplayString(_ctx.ba.bearbeitenderNutzer?.username ? `(${_ctx.ba.bearbeitenderNutzer.username})` : ''), 1))
                        : _createCommentVNode("", true),
                      (_ctx.ba.isLocal)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t("hzba.uebersicht.asynchron")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_tabs, {
                      "selected-view": _ctx.baSubpage,
                      onShowSummary: _ctx.showSummary,
                      onChangeTab: _ctx.changeTab
                    }, null, 8, ["selected-view", "onShowSummary", "onChangeTab"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      (_ctx.ba && _ctx.baSubpage !== 'summary')
                        ? (_openBlock(), _createBlock(_component_HzbaMainView, {
                            key: 0,
                            ba: _ctx.ba,
                            immobilie: _ctx.immobilie,
                            "route-name": _ctx.baSubpage
                          }, null, 8, ["ba", "immobilie", "route-name"]))
                        : (_ctx.baSubpage === 'summary')
                          ? (_openBlock(), _createBlock(_component_HzbaSummary, { key: 1 }))
                          : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock(_component_Skeleton, { key: 1 }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}